import { NavLink } from 'react-router-dom'
import { NAV_ITEMS } from '../../app/routes'
import { useAppState } from '../../state/store'

/** Lista de navegación (compartida por el sidebar). Cierra el sidebar en móvil al navegar. */
export function NavList() {
  const { dispatch } = useAppState()

  const closeOnMobile = () => {
    if (typeof window !== 'undefined' && window.innerWidth <= 768) {
      dispatch({ type: 'SET_SIDEBAR', open: false })
    }
  }

  return (
    <nav className="nav" aria-label="Navegación principal">
      <ul className="nav__list">
        {NAV_ITEMS.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              end={item.end}
              onClick={closeOnMobile}
              className={({ isActive }) =>
                isActive ? 'nav__link nav__link--active' : 'nav__link'
              }
            >
              <span className="nav__icon" aria-hidden="true">
                {item.icon}
              </span>
              <span className="nav__label">{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
